import { useEffect, useState } from 'react';
import { useRouter } from '~/utils/navigation';
import styled from 'styled-components';
import usePaymentPoll from '../../hooks/usePaymentPoll.js';
import constants from '../../common/lib/utils/constants.js';
import QuickDepositModal from '../../quick-deposit-beta/components/quick-deposit-modal.js';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';

const DEFAULT_POLL_PENDING_MINUTES = 2;

const QDcontainer = styled.div`
	height: 100%;
	overflow: auto;
`;

const MobilepayNativePrompt = ({ onPaymentSuccess, paymentResult, quickDepositFlow }) => {
	const [Ifrmaesrc, setIfrmaesrc] = useState();
	const router = useRouter();
	const transformPath = useContextualPathTransformer();
	const { pollResult, startPolling, stopPolling } = usePaymentPoll({
		accHistRef: paymentResult?.accHistRef,
		paymentType: constants.DEPOSIT
	});

	const timeoutPendingTransactionMinutes = DEFAULT_POLL_PENDING_MINUTES;

	useEffect(() => {
		startPolling();
		return () => {
			stopPolling();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		let timeoutId = null;
		if (timeoutPendingTransactionMinutes) {
			timeoutId = setTimeout(() => {
				onPaymentSuccess();
			}, timeoutPendingTransactionMinutes * 60000);
		}

		const receiveMessage = event => {
			const { IframeRedirectUrl } = event.data;
			if (window.location.origin === event.origin && IframeRedirectUrl) {
				router.push(transformPath(IframeRedirectUrl));
				window.removeEventListener('message', receiveMessage, false);
			}
		};
		window.addEventListener('message', receiveMessage, false);

		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('message', receiveMessage, false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeoutPendingTransactionMinutes]);

	if (pollResult?.state && pollResult.state !== constants.PENDING) {
		onPaymentSuccess();
	}

	useEffect(() => {
		const { externalUrl, externalParameters } = paymentResult || {};
		const redirectUrl = new URL(externalUrl);
		Object.entries(externalParameters).forEach(([key, value]) => {
			redirectUrl.searchParams.append(key, value);
		});
		return setIfrmaesrc(redirectUrl.href);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const renderContent = () => {
		if (Ifrmaesrc)
			return (
				<iframe
					src={Ifrmaesrc}
					title="mobilePay"
					height="600px"
					sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms"
				/>
			);

		return <div className="spinner" />;
	};

	return quickDepositFlow ? (
		<QuickDepositModal>
			<QDcontainer>{renderContent()}</QDcontainer>
		</QuickDepositModal>
	) : (
		<>{renderContent()}</>
	);
};

export default MobilepayNativePrompt;
